import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import ROUTES from 'constants/routes';
import { BRIGHT_GRAY } from 'constants/colors';
import { RESET_PASSWORD } from 'constants/data-testid';
import AppLogo, { appLogoVersions } from 'components/AppLogo';
import Grid from '@material-ui/core/Grid';
import Panel from 'components/Panel';
import { FormLink, LogoWrap } from '../styles';

const CheckEmail = ({ goToResetPassword, goToLogin }) => (
  <Panel
    padding="1rem 2.5rem"
    data-testid={RESET_PASSWORD.CHECK_EMAIL_CONTAINER}
  >
    <LogoWrap>
      <AppLogo
        color={BRIGHT_GRAY}
        version={appLogoVersions.v2}
        link='https://commerceblitz.com'
      />
    </LogoWrap>
    <Grid
      container
      justifyContent="center"
      style={{ padding: '1rem 0' }}
    >
      <h2>Check your email</h2>
    </Grid>
    <Grid
      container
      style={{ padding: '0 0 0.5rem 0' }}
    >
      <span>
        {`
          We've sent you an email. Click the link in the email to reset your password.
        `}
      </span>
    </Grid>
    <Grid container>
      <span>
        {`
          If you don't see the email, check other places it might be, 
          like your junk, spam, or other folders.
        `}
      </span>
    </Grid>
    <Grid
      container
      justifyContent="center"
      style={{ padding: '1rem 0 2rem 0' }}
    >
      <FormLink
        onClick={() => goToResetPassword()}
        data-testid={RESET_PASSWORD.LINK_RESEND_EMAIL}
      >
        {`
          I didn't receive the email
        `}
      </FormLink>
    </Grid>
    <Grid
      container
      justifyContent="center"
      style={{ padding: '1rem 0 0.5rem 0' }}
    >
      <span>Go back to &nbsp;</span>
      <FormLink
        onClick={() => goToLogin()}
        data-testid={RESET_PASSWORD.LINK_SIGN_IN}
      >
        Sign in
      </FormLink>
    </Grid>
  </Panel>
);

CheckEmail.propTypes = {
  goToResetPassword: PropTypes.func.isRequired,
  goToLogin: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  goToResetPassword: () => push(ROUTES.LOGIN.RESET_PASSWORD),
  goToLogin: () => push(ROUTES.LOGIN.BASE),
};

export default connect(null, mapDispatchToProps)(CheckEmail);
